export enum DeploymentEnvironments {
  GLOBAL_DEV = 'global_dev',
  GLOBAL_PERF = 'global_perf',
  THA_QA = 'tha_qa',
  THA_UAT = 'tha_uat',
  THA_PROD = 'tha_prod',
  LATAM_QA = 'latam_qa',
  LATAM_UAT = 'latam_uat',
  LATAM_PROD = 'latam_prod',
  JPN_QA = 'jpn_qa',
}

export enum Locales {
  EN = 'en',
  TH = 'th',
  ES = 'es',
  JA = 'ja',
}

export enum Countries {
  TH = 'th',
  CO = 'co',
  JP = 'jp',
}

export enum Tenants {
  GLOBAL = 'global',
  LATAM = 'latam',
  THA = 'tha',
  JPN = 'jpn',
}

export enum Environments {
  DEV = 'dev',
  PERF = 'perf',
  QA = 'qa',
  UAT = 'uat',
  PROD = 'prod',
}
